import React from 'react';
import { Box } from '@mui/material';
import { customSizes, spaces } from '../../../../assets/styles/themes/tokens';

const ColumnContainer: React.FC<{
  dataTestId: string;
  bgcolor: string;
  isLargeScreen: boolean;
  children: React.ReactNode;
}> = ({ dataTestId, bgcolor, isLargeScreen, children }) => {
  const { paymentInformationContainer } = customSizes;
  return (
    <Box
      data-testid={dataTestId}
      flex={1}
      bgcolor={bgcolor}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        paddingY: isLargeScreen ? paymentInformationContainer.paddingY : spaces.xxl,
        paddingX: spaces.lg,
      }}
    >
      <Box
        sx={{
          width: isLargeScreen
            ? paymentInformationContainer.width.desktop
            : paymentInformationContainer.width.mobile,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ColumnContainer;
